export const DEFAULT_HELP_EMAIL = 'help@streamline.com';
